import React from "react";
import { useTranslation } from "react-i18next";
import "./EstimatorHero.css";
import heroImg from "../../../../assets/images/estimator/estihero.jpg";

const EstimatorHero = ({ onCalculateNow }) => {
  const { t } = useTranslation();

  return (
    <section className="estimator-hero">
      <div className="estimator-container">

        {/* LEFT CONTENT */}
        <div className="estimator-left">

          <span className="estimator-badge">{t("sections.estimator.hero.badge")}</span>

          <h1>
            {t("sections.estimator.hero.title")} <br /> {t("sections.estimator.hero.titleLine2")}
          </h1>

          <p className="estimator-desc">{t("sections.estimator.hero.desc1")}</p>

          <p className="estimator-desc">{t("sections.estimator.hero.desc2")}</p>

          <button className="estimator-btn buttongyp" type="button" onClick={onCalculateNow}>
            {t("sections.estimator.hero.cta")}
          </button>

        </div>

        {/* RIGHT IMAGE */}
        <div className="estimator-right">
          <img src={heroImg} alt={t("sections.estimator.hero.imageAlt")} />
        </div>

      </div>
    </section>
  );
};

export default EstimatorHero;
